module.exports = __webpack_public_path__ + "img/user_modal.94da5afa.svg";